import { Directory, Encoding, Filesystem } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { Toast } from '@capacitor/toast';
import platform from './platform';

function convertBase64ToBlobData(
  base64Data: string,
  contentType: string = 'image/png',
  sliceSize = 512
) {
  const byteCharacters = atob(base64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

export function downloadBase64(
  base64string: string,
  fileName: string,
  type: string
) {
  if (platform.isWeb()) {
    downloadBase64FileInWebPlatform(base64string, fileName, type);
  } else if (platform.isAndroidOrIOS()) {
    downloadBase64FileInAndroidPlatform(base64string, fileName, type);
  }
}

function downloadBase64FileInWebPlatform(
  base64: string,
  fileName: string,
  type: string
) {
  const blobData = convertBase64ToBlobData(base64);
  const _win = window.navigator as any;

  if (_win && _win.msSaveOrOpenBlob) {
    _win.msSaveOrOpenBlob(blobData, fileName);
  } else {
    const blob = new Blob([blobData], { type });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
  }
}

async function downloadBase64FileInAndroidPlatform(
  base64: string,
  fileName: string,
  type: string
) {
  const extensions = {
    'image/png': '.png',
    'application/pdf': '.pdf',
  };

  try {
    const writeFileResult = await Filesystem.writeFile({
      path: `${fileName}${extensions[type]}`,
      directory: Directory.Cache,
      data: base64,
    });

    Share.share({ url: writeFileResult.uri });
  } catch (err) {
    Toast.show({ text: 'Não foi possível fazer o download do arquivo.' });
  }
}
